<template>
    <button
        v-if="!href"
        :type="type"
        class="inline-flex items-center border border-transparent font-normal text-xs tracking-widest focus:outline-none transition ease-in-out duration-300"
        :class="{
            ['bg-'+color+'-800 focus:border-'+color+'-900 hover:bg-'+color+'-700 active:bg-'+color+'-900 focus:shadow-outline-'+color] : color,
            ['bg-transparent'] : !color,
            ['px-5 py-3'] : padding == 'xl',
            ['px-4 pb-2 pt-2.5'] : padding == 'md',
            ['px-3 pb-1 pt-1.5'] : padding == 'sm',
            [ text ] : text,
            [ rounded ] : rounded,
            ['opacity-50'] : loading,
            ['uppercase'] : uppercase

        }"
    >
        <slot />
        <Spinner v-if="loading" class="ml-2 h-5 w-5"
            :class="{
                [ text ] : text,
            }"
        />
    </button>
    <InertiaLink
        v-else
        :type="type"
        :href="href"
        as="a"
        class="inline-flex items-center border border-transparent font-normal text-xs tracking-widest focus:outline-none transition ease-in-out duration-300"
        :class="{
            ['bg-'+color+'-800 focus:border-'+color+'-900 hover:bg-'+color+'-700 active:bg-'+color+'-900 focus:shadow-outline-'+color] : color && !customColor,
            ['bg-transparent'] : !color,
            ['px-5 py-3'] : padding == 'xl',
            ['px-4 pb-2 pt-2.5'] : padding == 'md',
            ['px-3 pb-1 pt-1.5'] : padding == 'sm',
            [ customColor ] : customColor,
            [ text ] : text,
            [ rounded ] : rounded,
            ['opacity-50'] : loading,
            ['uppercase'] : uppercase
        }"
    >
        <slot />
        <Spinner v-if="loading" class="ml-2 h-5 w-5 text-gray-900"
            :class="{
                [ text ] : text,
            }"
        />
    </InertiaLink>
</template>

<script>
    import Spinner from 'UI/Spinner';
    export default {
        components: { Spinner },
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            color: {
                type: String,
                default: 'gray'
            },
            padding: {
                type: String,
                default: 'md'
            },
            text: {
                type: String,
                default: 'text-white'
            },
            rounded: {
                type: String,
                default: 'rounded-md'
            },
            href: String,
            customColor: String,
            loading: Boolean,
            uppercase: {
                type: Boolean,
                default: true,
            }
        },

        setup(props) {

            return {

            }
        }
    }
</script>
